import React from 'react'
import UploadInput from '../UploadInput'

const TapTwo = () => {
  return <UploadInput />
}

export default TapTwo